import { auth, signInWithEmailAndPassword } from "../../firebase";
import { getAuth, signInAnonymously } from "firebase/auth";
import {
  isAdminReducer,
  loginReducer,
  logoutReducer,
  setEmailError,
  loginAnonymouslyReducer,
} from "../slices/authSlice";
import axios from "axios";
import { message } from "antd";
import { getCurrentUser } from "./userAction";

export function login(data) {
  return function (dispatch) {
    return signInWithEmailAndPassword(auth, data.email, data.password)
      .then((userAuth) => {
        dispatch(getCurrentUser());

        return userAuth.user.getIdTokenResult(true).then((idTokenResult) => {
          const token = idTokenResult.token;
          const refreshToken = userAuth.user.refreshToken;

          if (!refreshToken) {
            dispatch(logoutReducer());
            throw new Error("NO_REFRESH_TOKEN");
          }

          dispatch(
            loginReducer({
              email: data.email,
              token,
              refreshToken,
            }),
          );

          return { email: data.email, token, refreshToken };
        });
      })
      .catch((error) => {
        console.error("Firebase login error:", error);
        throw error; // ✅ REQUIRED
      });
  };
}

export const loginAnonymously = () => {
  return async (dispatch) => {
    const auth = getAuth();
    try {
      const userCredential = await signInAnonymously(auth);
      const user = userCredential.user;
      const token = await user.getIdToken();
      localStorage.setItem("firebaseAuthToken", token);
      dispatch(loginAnonymouslyReducer(token));
    } catch (error) {
      console.error("Anonymous login failed:", error);
    }
  };
};

export const getUserRole = (payload) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_API}users/isAdmin?email=${payload}`,
    );
    if (response.status === 200) {
      console.log("isAdmin response:", response.data);
      dispatch(isAdminReducer(response.data));
      return response;
    }
  } catch (err) {
    if (
      err.response?.status === 400 &&
      err.response?.data?.message === "User was not found"
    ) {
      dispatch(setEmailError("Ky e-mail nuk ekziston."));
      throw new Error("EMAIL_NOT_FOUND");
    }

    console.error("Server error while fetching role:", err);
    throw new Error("SERVER_ERROR");
  }
};
